// extracted by mini-css-extract-plugin
module.exports = {"black":"dh-dh-klima-spesial-english-black--f32a6c8cc1d184c8b270f761d293ccd6","solidColor":"dh-dh-klima-spesial-english-solidColor--2166b7dee9a8b35afb09ad182893d39b"};